<div class="card-body">
    <div id="apex-radialbar-gradient-circle-chart"></div>
</div>